import React from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Fill } from '../../../ui/Fill';
import { useResolve } from '../../Container';
import { UIPing } from './Ping';
import { PingStore } from './PingStore';
import { RenderUIPing } from './RenderPing';

const RenderPings = () => {
    const pings = useObserver(useResolve(PingStore));
    return <>
        {pings.map(x => x instanceof UIPing ? <RenderUIPing key={x.id} ping={x} /> : null)}
    </>;
};

export const UpperPresentLayer = React.memo(() => {

    return <Fill id="upper-present-layer" pointerEvents="none" zIndex="99">
        {/* <RenderPings /> */}
    </Fill>;
});
